import * as React from 'react';
import SimpleReactLightbox from 'simple-react-lightbox';
import { WPBlockProps } from './types';
import GalleryTile from '../images/gallery-tile';

export default function WpGallery({ block }: WPBlockProps): JSX.Element | null {
  const images = Array.isArray(block.attributes?.images)
    ? block.attributes.images.map((image) => {
        image.caption = image.caption || ' ';

        return image;
      })
    : undefined;

  if (!images) {
    return null;
  }

  const styleClasses: string[] = block.attributes?.className?.split(' ') ?? [];

  return (
    <SimpleReactLightbox>
      <GalleryTile
        caption={block.attributes.caption}
        images={images}
        styleClass={styleClasses.join(' ')}
        showImage={!styleClasses.includes('gallery-tile--no-image')}
        showAll={styleClasses.includes('gallery-tile--show-all')}
        columns={block.attributes.columns}
        innerBlocks={block.innerBlocks}
      />
    </SimpleReactLightbox>
  );
}
